module.exports = __webpack_public_path__ + "img/logo.ecd8e882.png";